var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.teacher)?_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('Breadcrumbs',{attrs:{"headline":_vm.teacher.name,"link":[{ text: 'Giáo viên', href: '../teachers' }]}})],1):_vm._e(),(_vm.teacher)?_c('TeacherProfile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }